<div class="tds-row tds-u-mt2">
    <div class="tds-col-xxlg-4 tds-col-xlg-4 tds-col-lg-6 tds-col-md-7 tds-col-sm-12 tds-col-xs-12 " >
        <tds-dropdown 
            name="dropdown" 
            label="Period" 
            label-position="outside" 
            placeholder="Select week" 
            size="sm" 
            class="tds-u-mb2"
            open-direction="auto"> 
            <tds-dropdown-option value="{{week.weekNo}}" (click)="weekSelected(week)" *ngFor="let week of weeks"> 
                {{week.displayWeek}} <span style="color: blue">{{getWeekOptionText(week)}}</span>
            </tds-dropdown-option> 
        </tds-dropdown>

        <h4 *ngIf="!isTimeCardEditable()" class="text-center text-success">
            {{'Timecard ' + selectedWeek.timeCard.status.toLowerCase()}}
        </h4>
   
        <tds-dropdown 
            name="dropdown" 
            label="Template" 
            label-position="outside" 
            placeholder="Select template" 
            size="sm"
            open-direction="auto"> 
            <tds-dropdown-option value="{{template.name}}" (click)="setSelectedTemplate(template)" *ngFor="let template of templates"> 
                {{template.name}}
            </tds-dropdown-option> 
        </tds-dropdown>

        <div class="tds-row tds-u-mb1">
            <div class="full-width">
                <div class="tds-no-padding" style="width:125px;float: left;padding-right: var(--tds-spacing-layout-4);padding-top: var(--tds-spacing-layout-8);">
                    <tds-button type="submit" 
                        fullbleed  
                        variant="primary" 
                        [disabled]="isTemplateSelected()" 
                        size="sm" 
                        text="Apply Template"
                        (click)="getTemplate()">
                    </tds-button>
                </div>
                <div class="tds-no-padding" style="width:125px;padding-top: var(--tds-spacing-layout-8);float: right;">
                    <tds-button type="button" 
                        fullbleed  
                        variant="secondary" 
                        id="deleteReportTemplatesModal"
                        size="sm" 
                        text="Delete template" >
                    </tds-button>
                </div>
                <div class="tds-no-padding tds-u-mr1" style="width:125px;padding-top: var(--tds-spacing-layout-8);float: right;">
                    <tds-button type="button" 
                        fullbleed  
                        variant="secondary" 
                        id="addReportTemplatesModal"
                        [disabled]="isDisabledSaveTemplate()" 
                        size="sm" 
                        text="Add template" >
                    </tds-button>
                </div>
            </div>
        </div>
    </div>

    <div class="tds-col-xxlg-8 tds-col-xlg-8 tds-col-lg-6 tds-col-md-5 tds-col-sm-12 tds-col-xs-12 tds-u-pt2">
        <div class="tds-u-mr1" style="width:75px;padding-top: var(--tds-spacing-layout-8);padding-left: var(--tds-spacing-layout-8);float: left;">
            <tds-button 
                type="primary" 
                variant="primary" 
                size="sm" 
                text="Save" 
                fullbleed
                (click)="save('save')" 
                [disabled]="isSaveDisabled()"
                title="Save the timecard. Changes can be made after this action.">
            </tds-button>
        </div>

        <div class="tds-u-mr3" style="width:75px;padding-top: var(--tds-spacing-layout-8);float: left;">
            <tds-button  
                text="Submit" 
                id="sumbitCardModal"
                fullbleed
                size="sm"
                [disabled]="isSaveDisabled()"
                title="Submit the timecard. Changes cant be made after this action but you may delete submitted timecards if Delete button is enabled."
                (click)="showSubmitQuery = true;">
            </tds-button> 
        </div>

        <div style="padding-top: var(--tds-spacing-layout-8);width: 100px;float: right;">
            <tds-button 
                type="primary" 
                variant="danger"
                size="sm"  
                id="deleteCardModal"
                fullbleed
                text="Delete card"
                [disabled]="isDeleteDisabled()"
                title="Delete the timecard from database.">
            </tds-button>    
        </div>
    </div>
</div>

<app-str-spinner [message]="''"></app-str-spinner>

<div class="tds-row table-container  tds-u-m2">
    <tds-table 
        vertical-dividers="false" 
        compact-design="true" 
        responsive="true" 
        no-min-width>
        <tds-table-toolbar>
            <div slot="end" class="tds-u-flex tds-u-align-items-center tds-u-h-100 tds-u-gap1">
                <h2 style="color: var(--tds-blue-500);">
                    {{selectedWeek.displayWeek.toUpperCase()}} 
                </h2>
            </div>
        </tds-table-toolbar>
        <tds-table-header>
            <tds-header-cell cell-value="Project"></tds-header-cell>
            <tds-header-cell cell-value="Task"></tds-header-cell>
            <tds-header-cell cell-value="Mon" [title]="getDateFromWeekDay(0)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Tue" [title]="getDateFromWeekDay(1)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Wed" [title]="getDateFromWeekDay(2)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Thu" [title]="getDateFromWeekDay(3)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Fri" [title]="getDateFromWeekDay(4)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Sat" [title]="getDateFromWeekDay(5)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Sun" [title]="getDateFromWeekDay(6)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Total" title="Total hours"  text-Align="right"></tds-header-cell>
            <tds-header-cell text-Align="left"></tds-header-cell>
        </tds-table-header>

        <tds-table-body>
            <tds-table-body-row *ngFor="let timecardRow of selectedWeek.timeCard.timecardRows; let i = index">
                <tds-body-cell class="hourrowprojandtask" disablePadding="true" >
                    <tds-dropdown 
                        *ngIf="timecardRow.project.projNo == ''"
                        filter 
                        size="sm" 
                        open-direction="auto"> 
                        <tds-dropdown-option value="{{project.projNo}}" 
                            (click)="selectProject(timecardRow, project, projectCtrl)" 
                            *ngFor="let project of filteredProjects" > 
                            {{project.projNo}} {{project.projName}}
                            
                        </tds-dropdown-option> 
                    </tds-dropdown>

                    <div  *ngIf="timecardRow.project.projNo != ''t">
                        <div class="tds-body-02 tds-u-pt1">
                            {{timecardRow.project.displayName}}
                        </div>
                        <div class="tds-u-pt1" *ngIf="timecardRow.invalidProj">
                            <span [title]="timecardRow.message" class="material-icons message">error</span>
                        </div>
                    </div>
                </tds-body-cell >

                <tds-body-cell class="hourrowprojandtask" disablePadding="true" [class.loading]="timecardRow.tasksLoading">
                    <tds-dropdown *ngIf="!!timecardRow.project && timecardRow.project.tasks.length > 1" 
                        label-position="inside" 
                        size="sm" 
                        open-direction="auto"> 
                        <tds-dropdown-option value="{{task.taskNo}}" (click)="setSelectedTask(timecardRow, task)" 
                            *ngFor="let task of timecardRow.project?.tasks"> 
                            {{task.taskName}}: {{task.expType}}
                        </tds-dropdown-option> 
                    </tds-dropdown>

                    <div class="tds-u-pt1 tds-body-02" *ngIf="!!timecardRow.project && timecardRow.project.tasks?.length == 1">
                        {{timecardRow.task.taskName}}: {{timecardRow.task.expType}}
                    </div>
                    <div class="tds-u-pt1" *ngIf="timecardRow.invalidTask">
                        <span [title]="timecardRow.message" class="material-icons message">error</span>
                    </div>
                </tds-body-cell >
                
                <tds-body-cell class="hourfieldtd" disablePadding="true">
                    <tds-text-field  tds-no-padding
                        name="hourmonday"
                        type="text"
                        class="hourfieldinput"
                        size="sm"
                        state="default"
                        label-position="no label"
                        no-min-width
                        ngDefaultControl 
                        placeholder="0" 
                        [(ngModel)]="timecardRow.mon" 
                        (ngModelChange)="setDirty(true)"
                        [disabled]="isRowDiabled(0, timecardRow)"> 
                    </tds-text-field> 
                </tds-body-cell >

                <tds-body-cell class="hourfieldtd" disablePadding="true">
                    <tds-text-field  tds-no-padding
                        name="hourtueday"
                        type="text"
                        class="hourfieldinput"
                        size="sm"
                        state="default"
                        label-position="no label"
                        no-min-width
                        ngDefaultControl 
                        placeholder="0" 
                        [(ngModel)]="timecardRow.tue" 
                        (ngModelChange)="setDirty(true)"
                        [disabled]="isRowDiabled(1, timecardRow)"> 
                    </tds-text-field>               
                </tds-body-cell >

                <tds-body-cell class="hourfieldtd" disablePadding="true" >
                    <tds-text-field  tds-no-padding
                        name="hourwedday"
                        type="text"
                        class="hourfieldinput"
                        size="sm"
                        state="default"
                        label-position="no label"
                        no-min-width
                        ngDefaultControl 
                        placeholder="0" 
                        [(ngModel)]="timecardRow.wed" 
                        (ngModelChange)="setDirty(true)"
                        [disabled]="isRowDiabled(2, timecardRow)"> 
                    </tds-text-field>      
                </tds-body-cell >

                <tds-body-cell class="hourfieldtd" disablePadding="true" >
                    <tds-text-field  tds-no-padding
                        name="hourthuday"
                        type="text"
                        class="hourfieldinput"
                        size="sm"
                        state="default"
                        label-position="no label"
                        no-min-width
                        ngDefaultControl 
                        placeholder="0" 
                        [(ngModel)]="timecardRow.thu" 
                        (ngModelChange)="setDirty(true)"
                        [disabled]="isRowDiabled(3, timecardRow)"> 
                    </tds-text-field>
                </tds-body-cell >

                <tds-body-cell class="hourfieldtd" disablePadding="true" >
                    <tds-text-field  tds-no-padding
                        name="hourfriday"
                        type="text"
                        class="hourfieldinput"
                        size="sm"
                        state="default"
                        label-position="no label"
                        no-min-width
                        ngDefaultControl 
                        placeholder="0" 
                        [(ngModel)]="timecardRow.fri" 
                        (ngModelChange)="setDirty(true)"
                        [disabled]="isRowDiabled(4, timecardRow)"> 
                    </tds-text-field>
                </tds-body-cell >

                <tds-body-cell class="hourfieldtd" disablePadding="true" >
                    <tds-text-field  tds-no-padding
                        name="hoursatday"
                        type="text"
                        class="hourfieldinput"
                        size="sm"
                        state="default"
                        label-position="no label"
                        no-min-width
                        ngDefaultControl 
                        placeholder="0" 
                        [(ngModel)]="timecardRow.sat" 
                        (ngModelChange)="setDirty(true)"
                        [disabled]="isRowDiabled(5, timecardRow)"> 
                    </tds-text-field>               
                </tds-body-cell>

                <tds-body-cell class="hourfieldtd" disablePadding="true">
                    <tds-text-field  tds-no-padding
                        name="hoursunday"
                        type="text"
                        class="hourfieldinput"
                        size="sm"
                        state="default"
                        label-position="no label"
                        no-min-width
                        ngDefaultControl 
                        placeholder="0" 
                        [(ngModel)]="timecardRow.sun" 
                        (ngModelChange)="setDirty(true)"
                        [disabled]="isRowDiabled(6, timecardRow)"> 
                    </tds-text-field>               
                </tds-body-cell>

                <tds-body-cell class="totalhourfieldtd" disablePadding="true">
                    <div class="tds-u-pt2 tds-headline-06 total">
                        {{timecardRow.total.toFixed(1)}} h
                    </div>
                </tds-body-cell>

                <tds-body-cell disablePadding="true" title="Delete row (will not save the card)">
                    <div class="pull-right" >
                        <tds-button type="primary" 
                            variant="danger" 
                            (click)="removeRow(i)"
                            size="sm"   
                            [disabled]="isDeleteDisabled()">
                            <tds-icon slot="icon" size="16px" name="trash"></tds-icon>
                        </tds-button>                        
                    </div>
                </tds-body-cell>
            </tds-table-body-row>

            <tds-table-body-row class="total-row">
                <tds-body-cell disablePadding="true">
                    <tds-button type="button" 
                        variant="secondary" 
                        (click)="addRow()"
                        size="sm" 
                        text="Add row"
                        *ngIf="isTimeCardEditable()"
                        title="Add report row">
                        <tds-icon slot="icon" size="16px" name="plus"></tds-icon>
                    </tds-button>                        
                </tds-body-cell>

                <tds-body-cell disablePadding="true"></tds-body-cell>

                <tds-body-cell class=" tds-headline-06" >
                    <div class="tds-u-pt2 day-total">
                        {{selectedWeek.timeCard.monTotal.toFixed(1)}} h
                    </div>
                </tds-body-cell>

                <tds-body-cell class=" tds-headline-06" >
                    <div class="tds-u-pt2 day-total">
                        {{selectedWeek.timeCard.tueTotal.toFixed(1)}} h
                    </div>
                </tds-body-cell>

                <tds-body-cell class=" tds-headline-06" >
                    <div class="tds-u-pt2 day-total">
                        {{selectedWeek.timeCard.wedTotal.toFixed(1)}} h
                    </div>
                </tds-body-cell>

                <tds-body-cell class=" tds-headline-06" >
                    <div class="tds-u-pt2 day-total">
                        {{selectedWeek.timeCard.thuTotal.toFixed(1)}} h
                    </div>
                </tds-body-cell>

                <tds-body-cell class=" tds-headline-06" >
                    <div class="tds-u-pt2 day-total">
                        {{selectedWeek.timeCard.friTotal.toFixed(1)}} h
                    </div>
                </tds-body-cell>

                <tds-body-cell class=" tds-headline-06" >
                    <div class="tds-u-pt2 day-total">
                        {{selectedWeek.timeCard.satTotal.toFixed(1)}} h
                    </div>
                </tds-body-cell>

                <tds-body-cell class="tds-headline-06" >
                    <div class="tds-u-pt2 day-total">
                        {{selectedWeek.timeCard.sunTotal.toFixed(1)}} h
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-headline-06 tds-u-pt2 total">
                        {{selectedWeek.timeCard.total.toFixed(1)}} h
                    </div>
                </tds-body-cell>

                <tds-body-cell title="Delete all rows (will not save the card)">
                    <div class="pull-right">
                        <tds-button type="primary" 
                            variant="danger" 
                            (click)="removeAllRows()"
                            size="sm"
                            [disabled]="selectedWeek.timeCard.timecardRows.length == 0">
                            <tds-icon slot="icon" size="16px" name="trash"></tds-icon>
                        </tds-button>                        
                    </div>
                </tds-body-cell>
            </tds-table-body-row>
        </tds-table-body>

    </tds-table>
</div>  

<div class="tds-col-xxlg-4 tds-col-xlg-4 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12 tds-u-mt2">
    <tds-textarea 
        rows="3"  
        name="EmpComment"
        class="hourfieldinput"
        state="default"
        label="Comment"
        label-position="outside"
        no-min-width
        ngDefaultControl 
        placeholder="Comment text"  
        [(ngModel)]="selectedWeek.timeCard.empComment" 
        (ngModelChange)="setDirty(true)"
        [disabled]="!isTimeCardEditable()">
    </tds-textarea> 
</div>


<app-toaster></app-toaster>

<!-- -------------------------------------------------- -->
<!--Modals-->
<!-- -------------------------------------------------- -->

<!--Submit card-->
<tds-modal
    header="Submit timecard"
    selector="#sumbitCardModal"
    show="false" 
    id="submit-card-modal"
    size="sm"
    actions-position="static"
    prevent="false" > 
    <span slot="body">
        <p>Are you sure you want to submit the current time card?</p>
    </span>
    <span slot="actions"> 
        <tds-button data-dismiss-modal fullbleed style="width: 100px;" size="sm" text="Submit" type="primary" (click)="save('submit')" class="tds-u-mr1"></tds-button> 
        <tds-button data-dismiss-modal fullbleed style="width: 100px;" size="sm" type="button" variant="secondary" text="Cancel"></tds-button> 
    </span> 
</tds-modal> 


<!--Delete card-->
<tds-modal
    header="Delete timecard"
    selector="#deleteCardModal"
    show="false" 
    id="delete-card-modal"
    size="sm"
    actions-position="static"
    prevent="false" > 
    <span slot="body">
        <p>Are you sure you want to delete the current time card?</p>
    </span>
    <span slot="actions"> 
        <tds-button data-dismiss-modal fullbleed style="width: 100px;" size="sm" text="Delete" type="primary" variant="danger" (click)="deleteTimecard()" class="tds-u-mr1"></tds-button> 
        <tds-button data-dismiss-modal fullbleed style="width: 100px;" size="sm" type="button" variant="secondary" text="Cancel"></tds-button> 
    </span> 
</tds-modal> 


<!--New template-->
<tds-modal
    header="New reporting template"
    selector="#addReportTemplatesModal"
    show="false" 
    id="add-report-template-modal"
    size="sm"
    actions-position="static"
    prevent="false" > 

    <span slot="body">
        <p>Current time card rows/hours will be used when creating the template</p>
        <tds-text-field 
            type="Text" 
            size="sm" 
            noMinWidth
            state="default"
            label="Label text" 
            ngDefaultControl
            label-position="inside" 
            placeholder="Enter new template name" 
            [(ngModel)]="templateName"            
            (ngModelChange)="setAlreadyExist()"> 
        </tds-text-field>
        <div *ngIf="templateAlreadyExists" class="tds-headline-06 tds-u-pt1 message" >
            A template with that name already exists
        </div>    
    </span>        

    <span slot="actions"> 
        <tds-button fullbleed style="width: 100px;" data-dismiss-modal size="sm" text="Add" [disabled]="templateName.trim().length == 0 || templateAlreadyExists" type="primary" (click)="saveTemplate()" class="tds-u-mr1"></tds-button> 
        <tds-button fullbleed style="width: 100px;" data-dismiss-modal size="sm" type="button" variant="secondary" text="Cancel"></tds-button> 
    </span> 
</tds-modal> 


<!--Delete template-->
<tds-modal style="height: 500px;"
    header="Delete template"
    selector="#deleteReportTemplatesModal"
    show="false" 
    id="delete-report-template-modal"
    size="sm"
    actions-position="static"
    prevent="false" > 

    <span slot="body">
        <p>Select template to delete</p>

        <div class="delete-dialog-content"> 
            <div *ngFor="let template of getListTemplates()" class="radiolist-item">
                <div *ngIf="selectedDeleteTemplate != null && this.selectedDeleteTemplate.name == template.name" class="radiolist-item-text"> 
                    <tds-radio-button checked name="templateslist" value="{{template.name}}" (click)="setSelectedDeleteTemplate(template)"> 
                        <span slot="label">{{template.name}}</span> 
                    </tds-radio-button >
                </div>
                <div *ngIf="selectedDeleteTemplate == null || this.selectedDeleteTemplate.name != template.name" class="radiolist-item-text"> 
                    <tds-radio-button name="templateslist" value="{{template.name}}" (click)="setSelectedDeleteTemplate(template)"> 
                        <span slot="label">{{template.name}}</span> 
                    </tds-radio-button >
                </div>
                
                <div style="height: 100%;"> 
                    <tds-divider orientation="horizontal"></tds-divider> 
                 </div>
            </div>
         </div> 
    </span>        

    <span slot="actions"> 
        <tds-button data-dismiss-modal fullbleed style="width: 100px;" size="sm" text="Delete" [disabled]="isDeleteTemplateDisabled()" type="primary"variant="danger" (click)="deleteTemplate()" class="tds-u-mr1"></tds-button> 
        <tds-button data-dismiss-modal fullbleed style="width: 100px;" size="sm" type="button" variant="secondary" text="Cancel" (click)=" selectedDeleteTemplate =null"></tds-button> 
    </span> 
</tds-modal> 

